export default __webpack_public_path__ + "static/media/homeabout4.fe4e8ab7.jpg";